/*
presetClient.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { ProfileStandardField } from '../profileStandardField';
import { RedactProfile } from '../redactProfile';
import { axiosInstance } from './apiClient'

export const getPresets = (
  deviceGuid: string,
  langCode: string
): Promise<RedactProfile[]> =>
  axiosInstance
    .get<RedactProfile[]>(`/profile/list/${deviceGuid}/${langCode}`)
    .then(r => r.data);

export const getStandardRedactionItems = (
  region: string,
  langCode: string
): Promise<ProfileStandardField[]> =>
  axiosInstance
    .get<ProfileStandardField[]>(`/fields/standard/${region}/${langCode}`)
    .then(r => r.data);

export const getDefaultStandardRedactionItems = (
  country: string,
  language: string,
  deviceGuid: string
): Promise<ProfileStandardField[]> =>
  axiosInstance
    .get<ProfileStandardField[]>(
      `/fields/standard/${country}/${language}/${deviceGuid}`
    )
    .then(r => r.data);

export const postPreset = (preset: RedactProfile): Promise<number> =>
  axiosInstance
    .post<number>("/profile", preset)
    .then(r => r.data);

export const updatePreset = (preset: RedactProfile): Promise<number> =>
  axiosInstance
    .patch<number>("/profile", preset)
    .then(r => r.data);

export const deletePreset = (id: string): Promise<{ success: boolean }> =>
  axiosInstance
    .delete<{ success: boolean }>(`/profile/${id}`)
    .then(r => r.data);
